import React from "react";
import { LoopDiagram } from "@/components/adaptive-loop/RegulationLoops";

const AssessmentLoopPrimer = () => (
  <section
    data-testid="assessment-loop-primer"
    className="mt-14 max-w-[980px]"
    aria-labelledby="assessment-loop-heading"
  >
    <div className="max-w-3xl">
      <div className="forr-overline">Where does your system go under demand?</div>
      <h2
        id="assessment-loop-heading"
        className="mt-5 font-display forr-text-ink text-3xl sm:text-4xl font-medium tracking-[-0.025em] leading-tight"
      >
        The assessment looks for where your activation–recovery process may be
        getting interrupted.
      </h2>
      <p className="mt-5 text-base font-light forr-text-soft leading-relaxed">
        Your responses help distinguish between a repeated route toward
        outsourced relief and a route that can be redirected through matched
        physiological input, parasympathetic recovery, and homeostasis.
      </p>
    </div>

    <div className="mt-9 grid md:grid-cols-2 gap-5">
      <article
        className="rounded-[26px] p-4 sm:p-6 overflow-hidden"
        style={{
          background:
            "radial-gradient(circle at 50% 38%, #24292D 0%, #111315 58%, #08090A 100%)",
          border: "1px solid #30363A",
        }}
      >
        <div className="px-2">
          <div className="text-[10px] uppercase tracking-[0.26em] text-[#929A9F]">
            Reinforced dependency
          </div>
          <h3 className="mt-2 font-display text-xl font-medium text-[#F4F1EA]">
            The Dependency Loop
          </h3>
        </div>
        <LoopDiagram
          variant="dependency"
          size="compact"
          showDescriptions={false}
          testId="assessment-dependency-loop"
        />
        <p className="px-2 pb-2 text-sm font-light leading-relaxed text-[#AEB4B7]">
          Activation moves through emotional reactivity into outsourced relief.
          Repetition can make the same route easier to recruit under future
          demand.
        </p>
      </article>

      <article
        className="rounded-[26px] p-4 sm:p-6 overflow-hidden forr-surface"
        style={{
          background:
            "radial-gradient(circle at 50% 38%, rgba(214,241,237,0.75) 0%, #FBF9F4 58%, #F7F5F0 100%)",
          border: "1px solid var(--forr-line)",
        }}
      >
        <div className="px-2">
          <div className="forr-overline">Adaptive recovery</div>
          <h3 className="mt-2 font-display forr-text-ink text-xl font-medium">
            The Adaptive Loop
          </h3>
        </div>
        <LoopDiagram
          variant="adaptive"
          size="compact"
          showDescriptions={false}
          testId="assessment-adaptive-loop"
        />
        <p className="px-2 pb-2 text-sm font-light leading-relaxed forr-text-soft">
          A matched physiological input redirects activation toward deliberate
          recovery and a functional homeostatic range.
        </p>
      </article>
    </div>

    <div
      className="mt-6 rounded-2xl p-5 sm:p-6"
      style={{
        backgroundColor: "var(--forr-teal-tint)",
        border: "1px solid var(--forr-teal-soft)",
      }}
    >
      <p className="font-display forr-text-ink text-lg font-medium">
        Assess your state. Break the loop.
      </p>
      <p className="mt-2 text-sm font-light forr-text-soft leading-relaxed">
        The assessment identifies the current pattern, the most useful
        interruption point, what your body can receive today, and where a
        repeatable physiological input can fit into the next seven days.
      </p>
    </div>
  </section>
);

export default AssessmentLoopPrimer;

